<style scoped lang="scss" type="text/scss">
    .present-container {

    }
</style>

<template>
    <div class="present-container">
        <el-form :model="presentInfo" :rules="rules" ref="form" label-width="100px">
            <block-divider>教师情况</block-divider>

            <two-cols-row>
                <el-form-item label="男教师人数" prop="male_teachers_number" slot="left">
                    <el-input v-model="presentInfo.male_teachers_number"></el-input>
                </el-form-item>
                <el-form-item label="女教师人数" prop="female_teachers_number" slot="right">
                    <el-input v-model="presentInfo.female_teachers_number"></el-input>
                </el-form-item>
            </two-cols-row>

            <block-divider style="margin-top: 0;">学生情况</block-divider>

            <two-cols-row>
                <el-form-item label="男学生人数" prop="male_students_number" slot="left">
                    <el-input v-model="presentInfo.male_students_number"></el-input>
                </el-form-item>
                <el-form-item label="女学生人数" prop="female_students_number" slot="right">
                    <el-input v-model="presentInfo.female_students_number"></el-input>
                </el-form-item>
            </two-cols-row>

            <el-form-item class="submit-buttons">
                <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
                <el-button @click="reset()">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import TwoColsRow from '../../../../../components/el-form-item-aux/two-cols-row/index';
    import BlockDivider from '../../../../../components/divider/block';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            TwoColsRow,
            BlockDivider
        },
        data () {
            const checkNumber = async (rule, value, callback) => {
                if (isNaN(+value)) {
                    callback(new Error('人数只能是数字'));
                }
                if (parseInt(value) !== +value) {
                    callback(new Error('人数只能是整数'));
                }
                if (+value < 0) {
                    callback(new Error('人数不能小于 0'));
                }
                if (+value > 1000) {
                    callback(new Error('人数不能超过 1,000'));
                }
            };

            return {
                requesting: false,
                presentInfo: {},
                rules: {
                    male_teachers_number: [
                        {required: true, message: '请输入男教师人数', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ],
                    female_teachers_number: [
                        {required: true, message: '请输入女教师人数', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ],
                    male_students_number: [
                        {required: true, message: '请输入男学生人数', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ],
                    female_students_number: [
                        {required: true, message: '请输入女学生人数', trigger: 'blur'},
                        {validator: checkNumber, trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            currentManagedPlayerInfo () {
                return this.$store.state.player.currentManagedPlayerInfo;
            }
        },
        watch: {
            currentManagedPlayerInfo: {
                immediate: true,
                handler (info) {
                    this.presentInfo = this.extract(info.player_present);
                }
            }
        },
        methods: {
            extract (info) {
                return {
                    male_teachers_number: _.get(info, 'male_teachers_number', null),
                    female_teachers_number: _.get(info, 'female_teachers_number', null),
                    male_students_number: _.get(info, 'male_students_number', null),
                    female_students_number: _.get(info, 'female_students_number', null)
                };
            },
            update () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    this.$normalRequest('player/updatePresent', {
                        id: this.currentManagedPlayerId,
                        ...this.presentInfo
                    }, '更新成功', true, this, 'requesting').then(_ => {
                        this.$refs.form.clearValidate();
                        this.$store.dispatch('player/loadRegistrableManagedPlayerInfo').then();
                    }).catch(_ => {
                    });
                });
            },
            reset () {
                this.presentInfo = this.extract(this.currentManagedPlayerInfo.player_present);
                this.$refs.form.clearValidate();
            }
        }
    };
</script>
